import { useEffect, useState } from 'react';
import type { FormEvent } from 'react';
import { LuArrowLeft } from 'react-icons/lu';
import { LIMITS } from '../../shared/protocol';
import { NovaMark } from '../components/ui';
import { api, useMe } from '../lib/api';

const MIN_PASSWORD_LENGTH = 10;

export function Register() {
  const { me } = useMe();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [accepted, setAccepted] = useState(false);
  const [informed, setInformed] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (me?.user) location.replace('/');
  }, [me]);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api('/api/auth/register', { method: 'POST', body: { name, email, password, acceptTerms: accepted && informed } });
      location.assign('/');
    } catch (err) {
      setError((err as Error).message);
      setBusy(false);
    }
  };

  return (
    <div className="auth-screen">
      <a className="auth-back" href="/">
        <LuArrowLeft /> Ana sayfa
      </a>
      <form className="card auth-card" onSubmit={submit}>
        <a className="brand" href="/">
          <NovaMark size={36} />
          <span className="brand-name">Nova Class</span>
        </a>
        <h1>Öğretmen hesabı açın</h1>
        <p className="muted small">E-postanızı doğruladıktan sonra ilk dersinizi birkaç dakikada başlatabilirsiniz.</p>
        <label className="field">
          <span>Ad Soyad</span>
          <input id="register-name" autoComplete="name" autoFocus required maxLength={LIMITS.maxNameLength} value={name} onChange={(e) => setName(e.target.value)} />
        </label>
        <label className="field">
          <span>E-posta</span>
          <input id="register-email" type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
        </label>
        <label className="field">
          <span>Şifre (en az {MIN_PASSWORD_LENGTH} karakter)</span>
          <input id="register-password" type="password" autoComplete="new-password" required minLength={MIN_PASSWORD_LENGTH} value={password} onChange={(e) => setPassword(e.target.value)} />
        </label>
        <label className="check">
          <input id="register-terms" type="checkbox" checked={accepted} onChange={(e) => setAccepted(e.target.checked)} />
          <span>
            <a href="/kullanim-kosullari" target="_blank" rel="noopener">
              Kullanım Koşulları
            </a>
            ’nı ve{' '}
            <a href="/gizlilik" target="_blank" rel="noopener">
              Gizlilik Politikası
            </a>
            ’nı kabul ediyorum.
          </span>
        </label>
        <label className="check">
          <input id="register-kvkk" type="checkbox" checked={informed} onChange={(e) => setInformed(e.target.checked)} />
          <span>
            <a href="/kvkk" target="_blank" rel="noopener">
              KVKK Aydınlatma Metni
            </a>
            ’ni okudum.
          </span>
        </label>
        {error && <p className="form-error">{error}</p>}
        <button type="submit" className="btn btn-primary btn-block btn-lg" disabled={busy || !accepted || !informed}>
          {busy ? 'Hesap açılıyor…' : 'Hesap aç'}
        </button>
        <p className="muted small auth-note">
          Zaten hesabınız var mı? <a href="/giris">Giriş yapın</a>.
        </p>
      </form>
    </div>
  );
}
